var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-description"},[(!_vm.description)?_c('SkeletonLoader',{staticClass:"h-[48px] s:h-[42px] m-0"}):_c('VaimoTruncatedText',{attrs:{"text":_vm.description,"lines":2,"truncate":'by lines'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }